/*银行账户 */
import { $http, buildHeaders } from "./index";

//获取列表
export const bankAccount_page = (params) => {
  return $http.get("/admin/BankAccount/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const bankAccount_detail = (id) => {
  return $http.get("/admin/BankAccount/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加
export const bankAccount_add = (data) => {
  return $http.post("/admin/BankAccount/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const bankAccount_edit = (data) => {
  return $http.post("/admin/BankAccount/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const bankAccount_delete = (id) => {
  return $http.post(
    "/admin/BankAccount/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//修改状态
export const bankAccount_updateStatus = (data) => {
  return $http.post("/admin/BankAccount/updateStatus", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};
